import { readCache } from "@/store/action"
import { useQuery } from "@tanstack/react-query"
import type { UseQueryOptions } from "@tanstack/react-query"
import { getParam, getConfig as getConfigApi } from "@/client/sdk.gen"
import type { GetConfigResponse } from "@/client";

const queryKey = 'ConfigInfo'
const keys = [
  'startTime',
  'endTime',
  'missionStopAt',
  'specialDaysSpin',
  'specialDaySpinMultiplier',
  'serverAccSpinProgress',
  'matchPredictionGroupPointBetStep',
  'matchPredictionGroupMinPointBet',
  'matchPredictionGroupMaxPointBet',
  'matchPredictionGroupMaxHopeStar',
  'matchPredictionSemiPointBetStep',
  'matchPredictionSemiMinPointBet',
  'matchPredictionSemiMaxPointBet',
  'matchPredictionSemiMaxHopeStar',
  'matchPredictionFinalPointBetStep',
  'matchPredictionFinalMinPointBet',
  'matchPredictionFinalMaxPointBet',
  'matchPredictionFinalMaxHopeStar',
  'maxSpinAddPerDay',
  'rule',
  'title2',
  'des2',
  'title3',
  'des3',
  'title4',
  'des4',
  'title5',
  'des5',
  'title6',
  'des6',
  'title7',
  'des7',
  'kvVideo',
  'kvImage',
  'errors',
  'no_account_url',
  'no_account_msg',
  'infoStopAt',
  'secretMinTotalSpins',
  'secretRevealAt',
  'giftcodeLockSeconds',
  'giftcodeMaxAttempts',
  'syncDailyLimitDelayMs',
  'syncServerLimitDelayMs',
  'topScorerPredictionEndTime',
  'topScorerPredictionStartTime',
  'championPredictionEndTime',
  'championPredictionStartTime',
] as const;

type ParamKey = typeof keys[number];
type Params = Record<ParamKey, any>;
export const getConfig = () => {
  return readCache(queryKey) as Params & GetConfigResponse
}

export const useConfig = (options?: Partial<UseQueryOptions>) => {
  const opts = {
    queryKey: [queryKey],
    queryFn: async () => {
      const [responseParams, responseConfig] = await Promise.all([
        getParam({
          query: {
            ids: keys as any
          }
        }),
        getConfigApi(),
      ]);
      return {
        ...responseParams.data,
        ...responseConfig.data,
      } as Params & GetConfigResponse
    }
  }
  Object.assign(opts, options);

  return useQuery(opts)
}